// Moving-object renderer registry — the CODE half of a canvas. The Canvas
// Library module (database-backed, see api/canvas-library.js) pairs one of
// these with an editable label/description and an optional uploaded
// background photo; `key` here is what canvas_library.moving_object_type
// stores. `createStage(canvasEl, opts)` must return the shared
// { setMessages, onSelect, onHover, resize, destroy } interface and accepts
// an optional opts.backgroundImageUrl — see fireflies/renderer.js.
//
// label/description/isNightTheme here are just fallbacks (used before the
// Canvas Library API response loads, or if you want the default framing for
// a brand new moving object type) — the ones that show in the UI and
// propagate live come from the canvas_library row.
//
// To add a new moving object type later: create a folder under src/canvases/
// with its own renderer.js implementing that interface, import it here, add
// one entry to this array, and add the key to KNOWN_TYPES in
// api/canvas-library.js. No other file needs to change.

import { createFirefliesStage } from './fireflies/renderer';
import { createKoiPondStage } from './koi_pond/renderer';
import { createBirdsStage } from './birds/renderer';
import { createSunflowersStage } from './sunflowers/renderer';
import { createWhatsAppStage } from './whatsapp/renderer';

export const CANVAS_REGISTRY = [
  {
    key: 'fireflies',
    label: 'Fireflies (Night)',
    description: 'Fireflies drift over dark green bushes at night. Hover or tap a firefly to read its message.',
    isNightTheme: true,
    createStage: createFirefliesStage,
  },
  {
    key: 'koi_pond',
    label: 'Koi Fish (Day)',
    description: 'Koi fish swim across a sunlit pond by day. Hover or tap a koi to read its message.',
    isNightTheme: false,
    createStage: createKoiPondStage,
  },
  {
    key: 'birds',
    label: 'Birds in Flight (Day)',
    description: 'Birds soar across a bright sky with realistic wing flapping. Hover or tap a bird to read its message.',
    isNightTheme: false,
    createStage: createBirdsStage,
  },
  {
    key: 'sunflowers',
    label: 'Sunflowers Rising (Day)',
    description: 'Sunflowers shoot up from the ground, bloom, and follow the sun. Hover or tap a sunflower to read its message.',
    isNightTheme: false,
    createStage: createSunflowersStage,
  },
  {
    key: 'whatsapp',
    label: 'WhatsApp Messages',
    description: 'WhatsApp-style chat bubbles float up from the bottom, settle at the top, and never overlap. Hover or tap a bubble to read its message.',
    isNightTheme: false,
    createStage: createWhatsAppStage,
  },
];

export function getCanvasDefinition(key) {
  return CANVAS_REGISTRY.find((c) => c.key === key) || null;
}
